module.exports = __webpack_public_path__ + "static/media/replay.bea8d830.svg";